<script>
import GeneralTable from '@/components/GeneralComponents/GeneralTable.vue'
import GeneralModal from '@/components/GeneralComponents/GeneralModal.vue'
import GeneralButton from '@/components/GeneralComponents/GeneralButton.vue'
import useManpower from "@/composables/performance_management/effects_measurement/useManpower";

const manpower = useManpower()

export default {
  components: {GeneralTable, GeneralModal, GeneralButton},

  mounted() {
    this.fetchData()
  },

  props: {
    ...manpower.props
  },

  data() {
    return {
      ...manpower.data(),
    }
  },

  methods: {
    ...manpower.methods,
  }
}
</script>

<template>
  <div class="p-3">
    <div class="row justify-content-between align-items-end">
      <div class="col-md-4 text-right">
        <label class="form-label fw-bold">تعداد</label>
        <input
            type="number"
            class="form-control"
            v-model="newItem.count"
        />
      </div>

      <div class="col-md-4 text-right">
        <label class="form-label fw-bold">ساعت اشتغال</label>
        <input
            type="number"
            class="form-control"
            v-model="newItem.employment_hours"
        />
      </div>

      <div class="col-md-2">
        <GeneralButton @clicked="addItem"/>
      </div>
    </div>

    <hr class="my-3">

    <!-- Items Table -->
    <GeneralTable
        :headers="tableHeaders"
        :fields="tableFields"
        :items="items"
        :openEditModalMethod="openEditModal"
        @remove="removeItem"
        scrollable-class="table-scrollable-size-20"
    />

    <!-- Edit Item Modal -->
    <GeneralModal
        v-show="editedItem"
        count="ویرایش"
        modal-id="modalId"
        @save="handleUpdate"
    >
      <template v-if="editedItem">
        <div class="row justify-content-center align-items-end">
          <div class="col-md-6 text-right">
            <label class="form-label fw-bold">تعداد</label>
            <input
                type="number"
                class="form-control"
                v-model="editedItem.count"
            />
          </div>

          <div class="col-md-6 text-right">
            <label class="form-label fw-bold">ساعت اشتغال</label>
            <input
                type="number"
                class="form-control"
                v-model="editedItem.employment_hours"
            />
          </div>
        </div>
      </template>
    </GeneralModal>
  </div>
</template>

<style scoped>
/* To remove the numeric Input Flash */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
